import MapboxDraw from "@mapbox/mapbox-gl-draw";


MapboxDraw.constants.cursors.MOVE = MapboxDraw.constants.cursors.POINTER

const limited_simple_select = {
	
	startOnActiveFeature : function(state, e) {
		// Stop any already-underway extended interactions
		this.stopExtendedInteractions(state);

		// Disable map.dragPan immediately so it can't start
		this.map.dragPan.enable();


		// Set up the state for drag moving
		state.canDragMove = false;
		state.dragMoveLocation = e.lngLat;
	}
}
limited_simple_select.onMouseUp = limited_simple_select.onTouchEnd

export default limited_simple_select;